import { render, staticRenderFns } from "./blogs-category.vue?vue&type=template&id=537fc1b5&scoped=true"
import script from "./blogs-category.vue?vue&type=script&lang=js"
export * from "./blogs-category.vue?vue&type=script&lang=js"
import style0 from "./blogs-category.vue?vue&type=style&index=0&id=537fc1b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fc1b5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,PaginationComponent: require('/var/www/tubber-new/components/global/PaginationComponent.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default})
